import React, { useState } from 'react';
import { Formik, Field } from 'formik';
import { Button, Grid, Form, Message } from 'semantic-ui-react';
import * as Yup from 'yup';

import FormikInput from './FormikInput';
import { useHistory } from 'react-router';

import { HTTPError, AuthorizationInput } from '../../../src/types';
import authenticationService from '../services/authentication';

const Login = ({ setUser }: { setUser: Function }) => {

    const history = useHistory();
    const [ error, setError ] = useState('');

    const initialValues = {
        username: '',
        password: ''
    };

    const schema = Yup.object({
        username: Yup
            .string()
            .required('Username is required.')
            .min(3, 'Must be 3 or more characters.'),
        password: Yup
            .string()
            .required('Password is required.')
            .min(3, 'Must be 3 or more characters.')
    })

    const onSubmit = async (values: AuthorizationInput) => {
        try {
            const user = await authenticationService.signin(values);
            setUser(user);
            history.push('/')
        }
        catch (e){
            setError((e as HTTPError).response.data['error']);
        }
    };
    
    return (
        <Grid centered columns={2}>
            <Grid.Column>
                {error &&
                    <Message error content={error}/>
                }
                <Formik 
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                    validationSchema={schema}
                >
                    {({isValid, dirty, handleSubmit}) => 
                        <Form onSubmit={handleSubmit}>
                            <Field 
                                label="username"
                                placeholder="username"
                                name="username"
                                component={FormikInput}
                            />
                            <Field
                                label="password"
                                type="password"
                                placeholder="password"
                                name="password"
                                component={FormikInput}
                            />
                            <Button type="submit" disabled={!dirty || !isValid}>login</Button>
                        </Form>
                    }
                </Formik>
            </Grid.Column>
        </Grid>
    );
};

export default Login;